import * as React from "react";

import "./email-proof.scss";

import {cs}    from "@Common/react/chain-services";
import {chain} from "@Common/utils/fs";

import {groupEditors} from "../../../../common/group-editors";

import {DisplayName}    from "./display-name/display-name";
import {MailingImage}   from "./mailing-image/mailing-image";
import {RideAlongImage} from "./ride-along-image/ride-along-image";

export const EmailProof = ({agentId, initData, learnMoreUrl, representativeImage, next}) => cs(
    ["displayName", (_, next) => DisplayName({
        agentId,
        initData,
        next,
    })],
    ["rideAlongImage", ({}, next) => RideAlongImage({initData, next})],
    ({displayName, rideAlongImage}) => next({
        editor: groupEditors([
            displayName.editor,
            rideAlongImage.editor,
        ]),
        render: ({showErrors, templateOptions}) => (
            <div className="email-proof-93k">

                <div className="editing">
                    <div className="float">
                        {displayName.renderEdit({showErrors})}

                        {rideAlongImage.renderEditing({})}
                    </div>
                </div>

                <div className="preview">
                    <div {...{
                        className: "title",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Informed Delivery Preview",
                    }}>
                        Preview
                    </div>
                    <div {...{
                        className: "box",

                        "xd-qa-type": "card",
                        "xd-qa-name": "Email Proof",
                    }}>
                        {displayName.renderPreview({
                            className: "from",
                        })}

                        {MailingImage({
                            ...templateOptions?.product?.numberFolds <= 0 && (
                                chain(
                                    representativeImage?.url ?? initData?.representativeImage,
                                    (url) => !url && representativeImage?.maybeLoading ? {
                                        loading: true,
                                    } : {
                                        representativeImage: url,
                                        // loading: representativeImage?.loading,
                                    },
                                )
                            ),
                        })}

                        {!!learnMoreUrl && (
                            <div {...{
                                className: "learn-more",
                            }}>
                                <a {...{
                                    href: learnMoreUrl,
                                    target: "_blank",

                                    "xd-qa-type": "link",
                                    "xd-qa-name": "Learn More",
                                }}>
                                    Learn more about your mail <i className="fa fa-chevron-right"/>
                                </a>
                            </div>
                        )}

                        {rideAlongImage.renderPreview({
                            className: "ride-along-image",
                            href: learnMoreUrl,
                        })}
                    </div>
                </div>

            </div>
        ),
    }),
);

